<template>
  <div>
    <!-- 选择题目对话框 -->
    <el-dialog
      title="选择考试题目"
      v-model="dialogVisible"
      width="50%"
      @close="handleClose"
    >
      <el-form :model="form" ref="formRef" label-width="120px">
        <!-- 选择计划 -->
        <el-form-item label="选择计划">
          <el-select v-model="form.selectedPlan" placeholder="请选择计划">
            <el-option
              v-for="plan in plans"
              :key="plan.planId"
              :label="plan.planName"
              :value="plan.planId"
            />
          </el-select>
        </el-form-item>

        <!-- 题目选择 -->
        <el-form-item label="选择题目">
          <el-checkbox-group v-model="form.selectedQuestions">
            <el-checkbox
              v-for="question in questions"
              :key="question.id"
              :label="question.id"
            >
              {{ question.question }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios'
import { ElMessage } from "element-plus";
export default {
  props: {
    plans: {
      type: Array,
      required: true,
      default: () => []
    },  organizationID: {
      type: Number,
      required: true,

    },
    questions: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: true, // 控制对话框显示
      form: {
        selectedPlan: null, // 选择的计划ID
        selectedQuestions: [] // 选中的题目ID
      },
    };
  },
  methods: {
    // 提交选中的题目和计划
    submitForm() {

console.log(this.form.selectedPlan)

      if(!this.form.selectedPlan){
        ElMessage.error('请选择一个计划');
        return;
      }
      // 检查是否选择了至少一个题目
      if (this.form.selectedQuestions.length === 0) {
        ElMessage.error('请至少选择一个题目');
        return; // 终止提交
      }

      console.log('Selected plan:', this.form.selectedPlan);
      console.log('Selected questions:', this.form.selectedQuestions);

      // 提交选中的题目和计划ID到后端，或者执行其他操作
axios.put('/Manage/exam', {
  planId: this.form.selectedPlan,
  questionIds: this.form.selectedQuestions,
  organizationId:this.organizationID
}).then(response => {
if(response.data.success){
  ElMessage.success(response.data.data)
  // this.$emit('close');
}
else {
  ElMessage.error(response.data.errorMsg)
}
}).catch(error => {
 ElMessage.error("创建失败")
})

      // 关闭对话框
      // this.dialogVisible = false;
      this.$emit('close'); // 触发父组件的关闭事件
    },

    // 重置表单（可以在关闭对话框时清空选择）
    resetForm() {
      this.form.selectedPlan = null;
      this.form.selectedQuestions = [];

    },

    // 关闭对话框
    closeDialog() {
      // this.dialogVisible = false;
      this.$emit('close'); // 触发父组件的关闭事件
    }
  },
  // 处理@close事件，触发父组件的关闭事件
  handleClose() {
    this.resetForm(); // 重置表单
    this.$emit('close'); // 触发父组件的关闭事件
  }
};
</script>
